import { render, staticRenderFns } from "./Vacations.vue?vue&type=template&id=072db678&scoped=true"
import script from "./Vacations.vue?vue&type=script&lang=js"
export * from "./Vacations.vue?vue&type=script&lang=js"
import style0 from "./Vacations.vue?vue&type=style&index=0&id=072db678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072db678",
  null
  
)

export default component.exports